import { RDAlert } from './alert.class';
import { Component, OnInit, Input } from '@angular/core';
import { RDAlertService } from './alert.service';
import { trigger, transition, query, stagger, animate, keyframes, style } from '@angular/animations';

@Component({
  selector: 'rd-alert',
  template: `<div class="alertContainer" [@listAnimation]="alerts.length">
  <div *ngFor="let alert of alerts; let i = index" class="alert {{alert.alert.type}}Alert" (click)="closeAlert(i)">
    <span class="closeIcon"><i class="fas fa-times"></i></span>
    <div class="headerAlert">
      <span><i class="{{getIcon(alert.alert.type)}}"></i></span>
      {{ alert.alert.title }}
    </div>
    <div class="textAlert">
      {{alert.alert.text}}
    </div>
  </div>
</div>
`,
  styles: [`.alertContainer{position:fixed;top:5%;right:2%;width:30%;z-index:2}.alertContainer .alert{position:relative;cursor:pointer;width:100%;padding:6px;margin:6px 0;color:#fff}.alertContainer .alert .closeIcon{position:absolute;top:6px;right:6px}.alertContainer .alert .headerAlert{width:85%}.alertContainer .alert .headerAlert,.alertContainer .alert .textAlert{word-break:break-all}.alertContainer .alert.dangerAlert{background-color:rgba(186,90,90,.8)}.alertContainer .alert.warningAlert{background-color:rgba(186,186,90,.8)}.alertContainer .alert.successAlert{background-color:rgba(114,186,90,.8)}.alertContainer .alert.infoAlert{background-color:rgba(90,90,186,.8)}@media (max-width:650px){.alertContainer{width:50%;min-width:250px}}`],
  animations: [
    trigger('listAnimation', [
      transition('* => *', [
        query(':enter', stagger('300ms', [
          animate('.5s ease-in', keyframes([
            style({opacity: 0.2, transform: 'translateX(75%)', offset: 0}),
            style({opacity: 1, transform: 'translateX(0)', offset: 1.0}),
          ]))]), {optional: true}),
          query(':leave', stagger('300ms', [
            animate('.5s ease-in', keyframes([
              style({opacity: 1, transform: 'translateX(0)', offset: 0}),
              style({opacity: 0, transform: 'translateX(100%)', offset: 1.0}),
            ]))]), {optional: true})
      ])
    ])
  ]
})
export class RDAlertComponent implements OnInit {

  @Input() timer = 5;

  public alerts: Array<{alert: RDAlert, timer: any}> = [];

  constructor(private alertService: RDAlertService) { }

  ngOnInit() {
    this.alertService.getAlert().subscribe((alert: RDAlert) => {
      const newAlert = {alert: alert, timer: setTimeout(() => {
        this.deleteOnTimer(newAlert);
      }, this.timer * 1000)};
      this.alerts.push(newAlert);
    });
  }

  deleteOnTimer(closeAlert) {
    for (let i = 0; i < this.alerts.length; i++) {
      if (this.alerts[i].timer === closeAlert.timer) {
        this.alerts.splice(i, 1);
      }
    }
  }

  closeAlert(index) {
    clearTimeout(this.alerts[index].timer);
    this.alerts.splice(index, 1);
  }

  getIcon(type) {
    if (type === 'danger') {
      return 'fas fa-exclamation-triangle';
    } else if (type === 'warning') {
      return 'fas fa-exclamation';
    } else if (type === 'success') {
      return 'fas fa-check';
    } else if (type === 'info') {
      return 'fas fa-info';
    }
  }

}
